<script setup lang="ts">
defineProps<{
  product: SingleProduct
}>()
</script>

<template>
  <div class="relative pt-8 pb-20 sm:pt-20 sm:pb-56">
    <div class="mx-10 flex flex-col gap-4 text-center">
      <h1 class="font-headline text-4xl font-light sm:text-[3.125rem]" v-text="product.title" />
      <div
        v-if="product.intro"
        class="mx-auto max-w-lg text-base sm:text-[1.625rem]"
        v-html="product.intro"
      />
    </div>

    <UiProductsInfoCardList :product="product" />
  </div>
</template>
